import React, { useState, useCallback } from 'react';
import { Typo, Icon } from '@ers/ui';
import cookies from 'js-cookie';
import { Variants } from './Typo';

const cookieKey = 'COOKIE_WINDOW_CLOSED';
const Cookies = () => {
    const getCookie = () => {
        const cookie = cookies.get(cookieKey);
        return Boolean(cookie);
    };

    const setCookie = () => {
        cookies.set(cookieKey, '1', { expires: 365 });
        return true;
    };

    const [cookieExist, setCookieExist] = useState(getCookie());

    const handleClick = useCallback(() => {
        setCookieExist(setCookie());
    }, []);

    return (
        <>
            {!cookieExist && (
                <div className="cookies">
                    <div className="cookies__header">
                        <Typo.Subheader variant={Variants.WHITE} className="with-margin--bottom-1">
                            Pliki cookies&nbsp;
                            <span role="img" aria-label="cookie icon">🍪</span>
                        </Typo.Subheader>
                        <Icon name="close" onClick={handleClick} />
                    </div>
                    <Typo.Body variant={Variants.WHITE}>
                        Używamy plików cookies w celu: (1) umożliwienia Ci wysłania formularza rekrutacyjnego, (2) realizacji usług zgodnie z&nbsp;
                        <a
                            href="https://kandydat.erecruiter.pl/_files/Regulamin_swiadczenia_uslugi_Konto_Kandydata_2020-04-01.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underlined"
                        >
                            Regulaminem
                        </a>
                        , (3) analizy ruchu oraz Twojej aktywności na formularzu rekrutacyjnym i w Serwisie.
                        Kontynuując korzystanie z serwisu bez zmiany ustawień swojej przeglądarki,
                        wyrażasz zgodę na stosowanie plików cookies przez eRecruiter i Grupę Pracuj (Pracuj.pl) oraz naszych partnerów.
                        Zgodę możesz cofnąć w dowolnym momencie, zmieniając ustawienia swojej przeglądarki. Więcej informacji znajdziesz w&nbsp;
                        <a
                            href="https://kandydat.erecruiter.pl/_files/Polityka_Cookies_Konto_Kandydata_2020-04-01.pdf" target="_blank"
                            rel="noopener noreferrer"
                            className="underlined"
                        >
                            Politykę Cookies
                        </a>
                        .
                    </Typo.Body>
                </div>
            )}
        </>
    );
};

export default Cookies;